<div class="dashboard-historical-wrapper">
  <lib-prod-header [title]="'Cars total'" [icon]="'stacked_line_chart'" [style]="">
    <div echarts [options]="carsTotalOption"></div>
  </lib-prod-header>
  <lib-prod-header [title]="'Cars ratio'" [icon]="'percent'">
    <div echarts [options]="carsRatioOption"></div>
  </lib-prod-header>
  <lib-prod-header [title]="'Active dongles'" [icon]="'speaker_phone'">
    <div echarts [options]="activeDonglesOption"></div>
  </lib-prod-header>
  <lib-prod-header [title]="'Active dongles / Company'" [icon]="'speaker_phone'" *ngIf="showCompanyDongles()">
    <div echarts *ngFor="let option of companyDonglesOptions" [options]="option"></div>
  </lib-prod-header>
  <lib-prod-header [title]="'User activity'" [icon]="'groups'" *ngIf="!organization || organization.organizationType.id !== 2">
    <div echarts [options]="usersOption"></div>
  </lib-prod-header>
</div>
